import { MatPaginatorIntl } from '@angular/material/paginator';

export function getPtBrPaginatorIntl(): MatPaginatorIntl {
  const i18n = new MatPaginatorIntl();

  i18n.itemsPerPageLabel = 'Itens por página';
  i18n.nextPageLabel = 'Próxima página';
  i18n.previousPageLabel = 'Página anterior';
  i18n.firstPageLabel = 'Primeira página';
  i18n.lastPageLabel = 'Última página';

  i18n.getRangeLabel = (page: number, pageSize: number, length: number) => {
    if (length === 0 || pageSize === 0) {
      return `0 de ${length}`;
    }

    const start = page * pageSize + 1;
    const end = Math.min((page + 1) * pageSize, length);

    return `${start} – ${end} de ${length}`;
  };

  return i18n;
}
